"use strict";

export function initInScope($scope) {
   let close=  $scope.find('.js-notice-banner-close');
   let newsletterBanner=  $scope.find('.js-notice-banner');
   close.on('click', function (){
       document.cookie = "banner-closed=true; expires='';";
        newsletterBanner.addClass('d-none');
   })
}